import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import styles from '../TopUpStatusAlertBox.module.css';
import { FormattedMessage } from 'react-intl';
import messages from './Alerts.messages';

export const NotYetTopUpEligibleAlert = ({
    amountToRepayBeforeTopUp
}: {
    amountToRepayBeforeTopUp: number;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            iconName="infoCircleOutline"
            className={styles.blueAlertBox}
            iconClassName={styles.blueAlertBoxIcon}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            {...messages.notYetTopupEligilbeAlertText}
                            values={{
                                amount: (
                                    <FormattedCurrency
                                        value={amountToRepayBeforeTopUp}
                                    />
                                )
                            }}
                        />
                    </strong>{' '}
                    <FormattedMessage
                        {...messages.notYetTopupEligilbeAlertDescription}
                    />
                </>
            }
        />
    );
};
